import React from "react";
import LineCrudTableRowModal from "./LineCrudTableRowModal";
import ReactPaginate from "react-paginate";

const LineCrudTableModal = ({
                                clients,
                                listClientsWhitoutLine,
                                getAmountClientsWhitoutLine,
                                vinculedLine,
                                ListClientsWhitLine,
                                openModalVinculetedAlreadyExists,
                                vinculedClient,
                                amountClientsPages,
                                numberPageClient
                            }) => {

    const handlePageClick = async (data) => {
        listClientsWhitoutLine(data.selected + 1);
    };

    const handleResetList = () => {
        listClientsWhitoutLine(1);       
    }

    return (
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Clientes No Vinculados:</h6>
                </div>
                <div className="col d-flex justify-content-end" >
                    <div className="col-auto">
                        <button type="submit" className="btn btn-primary" onClick={handleResetList}>Cargar todos</button>
                    </div>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{border:'1px solid black'}}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" className="text-center">Nombres</th>
                            <th scope="col" className="text-center">Apellidos</th>
                            <th scope="col" className="text-center">Número de Documento</th>
                            <th scope="col" className="text-center">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        clients.length > 0 ? clients.map((el, i) => <LineCrudTableRowModal 
                                                                                        key={el._id} el={el} i={i} 
                                                                                        vinculedLine={vinculedLine}
                                                                                        ListClientsWhitLine={ListClientsWhitLine}
                                                                                        openModalVinculetedAlreadyExists={openModalVinculetedAlreadyExists}
                                                                                        vinculedClient={vinculedClient}
                                                                                        getAmountClientsWhitoutLine={getAmountClientsWhitoutLine}
                                                                                        />) :
                            <tr>
                                <td colSpan="5">Sin datos</td>
                            </tr>
                    }
                    </tbody>
                </table>
            </div>
             <div>
                <ReactPaginate
                    previousLabel={"Anterior"}
                    nextLabel={"Siguiente"}
                    breakLabel={"..."}
                    initialPage={numberPageClient - 1}
                    pageCount={amountClientsPages}
                    //Cuantas paginas quieres mostrar despues d elos 3 ...
                    marginPagesDisplayed={1}
                    //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
                    pageRangeDisplayed={2}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center mt-3"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                />
            </div>
        </div>
    );
}
export default LineCrudTableModal;
